/*
 * @Author: tao.zong
 * @Date: 2018-11-30 11:30:14
 * @Last Modified by: tao.zong
 * @Last Modified time: 2018-12-03 16:18:14
 */
import store from "@/store";
import * as types from "@/store/constants/types";

/* 
  随机消息的图标
  params: 图标的数组
*/

const randomIcon = (arr: any) => {
  const index = Math.floor(Math.random() * arr.length);
  return arr[index];
};

const getSpecialFollowNum = () => {
  const offer = store.getters[types.GETTER_SETTING_DATA].special_follow_offers;
  return offer ? offer[0].effect : 30;
};
//测试时间
let timetest = 30000;

/* 
  根据权重随机发送的notice
*/
class HandleAccordWeightSendNotice {
  //是否买过vip
  private isHasBuyVip = false;
  //用户信息中servers中vip的信息
  private findService: any = null;
  //用户信息
  private GxUserInfo: any = null;
  //通知发送的配置信息
  private levelNotification: any;
  private followerIcon = [
    "sp_noti_2_80",
    "sp_noti_6_80",
    "sp_noti_9_80",
    "sp_noti_10_80"
  ];
  private specialFollowerNotice = [
    {
      title: "Get it Before Anyone Else🤭",
      text: `Hi, Claim Today’s Offer to GET 50 Followers at ONLY $0.99 (Worth $9.99)🤑💰`,
      icon: randomIcon(this.followerIcon),
      customData: { type: "sepcial-follow-notice" }
    }
  ];
  private likeIcon = [
    "sp_noti_1_80",
    "sp_noti_3_80",
    "sp_noti_4_80",
    "sp_noti_5_80",
    "sp_noti_7_80",
    "sp_noti_8_80",
    "sp_noti_11_80"
  ];
  private specialLikeNotice = [
    {
      title: "How much to get 250 likes❓",
      text: "🙈I bet you NEVER guess!  👉🏼👉🏼Tap to see the price.",
      icon: randomIcon(this.likeIcon),
      customData: { type: "sepcial-like-notice" }
    },
    {
      title: "Dream Deals - Get Popular in A Sec🔥",
      text:
        "Over 5,000 users have got 250 likes at ONLY $0.99. GET IT before it’s done. 💸  ",
      icon: randomIcon(this.likeIcon),
      customData: { type: "sepcial-like-notice" }
    }
  ];
  private vipFreeTrialIcon = [
    "vip_noti_2_80",
    "vip_noti_3_80",
    "vip_noti_4_80",
    "vip_noti_5_80",
    "vip_noti_6_80",
    "vip_noti_8_80"
  ];
  private vipFreeTrialNotice = [
    {
      title: "It’s Absolutely FREE😻",
      text: "Grab yours FREE Followers 🆓",
      icon: randomIcon(this.vipFreeTrialIcon),
      customData: { type: "vip-free-trail-notice", index: "slide1" }
    },
    {
      title: "It’s Absolutely FREE😻",
      text: "Get FREE Followers for a Limited Time",
      icon: randomIcon(this.vipFreeTrialIcon),
      customData: { type: "vip-free-trail-notice", index: "slide0" }
    },
    {
      title: "Claim Your Benefit Before It’s Too Late",
      text: "❤️Get 999 Likes Within 1 minute⏰",
      icon: randomIcon(this.vipFreeTrialIcon),
      customData: { type: "vip-free-trail-notice", index: "slide6" }
    },
    {
      title: "🛡️ROYAL FULLY GUARANTEE 🛡️",
      text: "FREE Trial for your latest order. 100% NO DROP FOLLOWERS.",
      icon: randomIcon(this.vipFreeTrialIcon),
      customData: { type: "vip-free-trail-notice", index: "slide4" }
    },
    {
      title: "Treat yo’self to a FREE Trial of VIP",
      text: "Grab Now and Get up to 70% OFF",
      icon: randomIcon(this.vipFreeTrialIcon),
      customData: { type: "vip-free-trail-notice", index: "slide3" }
    },
    {
      title: "Totally Worry-Free",
      text: "More than 1,000,000 satisfied VIP users are recognized.",
      icon: randomIcon(this.vipFreeTrialIcon),
      customData: { type: "vip-free-trail-notice", index: "slide10" }
    }
  ];
  private LimitCoinsNotice = [
    {
      title: "💰 4X Value Coins💰",
      text: "Here comes the chance! 🔔 ",
      icon: "limited_noti_1_80",
      customData: { type: "limit-coin-notice" }
    }
  ];
  private luckyCoinIcon = ["lucky_noti_1_80", "lucky_noti_2_80"];
  private LuckyCoinsNotice = [
    {
      title: "💰 Win 1,000,000 Coins 💰",
      text: "Lucky Offer is here! Get it right Now!",
      icon: randomIcon(this.luckyCoinIcon),
      customData: { type: "lucky-coin-notice" }
    }
  ];
  private vipPackageIcon = ["vp_noti_1_80", "vp_noti_2_80"];
  private vipPackageNotice = [
    {
      title: "Exclusive VIP Discount",
      text: `🙌 Don't forget your 70 % OFF VIP Packages`,
      icon: randomIcon(this.vipPackageIcon),
      customData: { type: "vip-package-notice", index: "slide4" }
    }
  ];
  private earnCoinsNotice = [
    {
      title: "FREE FOLLOWERS Coming Soon🎉",
      text: "Hurry, use FREE COINS to get your followers or likes.😍",
      icon: "vip_noti_4_80",
      customData: { type: "earn-coin-notice" }
    }
  ];
  //vip过期
  private vipExpireNotice = [
    {
      title: "Reminder: The member has expired",
      text: "🆘 Orders will not be protected.",
      icon: "vip_noti_7_80",
      customData: {
        index: "slide0",
        type: "vip-expired-notice"
      }
    },
    {
      title: "VIP Benefit Expired",
      text: "You will immediately lose powerful IG growth. 🎢",
      icon: "vip_noti_7_80",
      customData: {
        index: "slide6",
        type: "vip-expired-notice"
      }
    },
    {
      title: "Renew VIP Membership 🎫",
      text: "24/7 exclusive customer service is at your service.",
      icon: "vip_noti_7_80",
      customData: {
        index: "slide10",
        type: "vip-expired-notice"
      }
    },
    {
      title: "Your membership has expired! 🚨",
      text: "Renew your VIP membership to grab your FREE followers Per day.",
      icon: "vip_noti_7_80",
      customData: {
        index: "slide1",
        type: "vip-expired-notice"
      }
    }
  ];
  //订阅follow的通知，第一条是粉丝小于1000的
  private subscripFollowNotice = [
    [
      {
        title: "🏆Almost Reach A New Achievement🏆",
        text:
          "Dear @username, you only need 1000-N followers to BEAT 69.6% of ALL the other users.",
        // icon: "",
        customData: {
          scrollPos: "less",
          type: "sub-follow-notice"
        }
      }
    ],
    [
      {
        title: "🚀 Powerful Growth Is Ready 📋",
        text:
          "Dear @username, a powerful IG followers growth for you to help you easily beat 85.3% of all the other users.",
        // icon: "",
        customData: {
          scrollPos: "more",
          type: "sub-follow-notice"
        }
      }
    ]
  ];
  //订阅like的通知， 第一条是粉丝小于10000的,定位不一样
  private subscripLikeNotice = [
    [
      {
        title: "Real likes, delivered automatically",
        text:
          "Why go out of your way to buy Instagram likes manually with every new upload?",
        // icon: "",
        customData: {
          scrollPos: "less",
          type: "sub-like-notice"
        }
      }
    ],
    [
      {
        title: "Real likes, delivered automatically",
        text:
          "Why go out of your way to buy Instagram likes manually with every new upload?",
        // icon: "",
        customData: {
          scrollPos: "more",
          type: "sub-like-notice"
        }
      }
    ]
  ];
  //总的权重
  private totalWeight: number = 0;
  //池子里需要随机发送的消息   luckycoin权重为30，earn coin权重为20 limit coin权重为40（不需要判断，直接在池子里）
  private needRandomNoticeList: any = [
    {
      notice: this.LuckyCoinsNotice,
      weight: 30
    },
    {
      notice: this.earnCoinsNotice,
      weight: 20
    },
    {
      notice: this.LimitCoinsNotice,
      weight: 40
    }
  ];

  public getsendRandomNoticeData = () => {
    timetest = 0;
    this.needRandomNoticeList = [
      {
        notice: this.LuckyCoinsNotice,
        weight: 30
      },
      {
        notice: this.earnCoinsNotice,
        weight: 20
      },
      {
        notice: this.LimitCoinsNotice,
        weight: 40
      }
    ];
    this.isHasBuyVip = this.jugeIsHasBuyVip();
    //初始化需要随机发送的消息池
    // this.jugeNoitceListHasFollowOrLike();
    this.jugeNoitceListHasVipPakage();
    this.jugeNoitceListHasVipTrialThreeDay();
    this.jugeNoticeHasExpiredVip();
    this.jugeNoticeHasSubscrip();
    this.calcNoticeWeight();
    this.levelNotification =
      store.getters[types.GETTER_SETTING_DATA] &&
      store.getters[types.GETTER_SETTING_DATA].level_notification
        ? store.getters[types.GETTER_SETTING_DATA].level_notification
        : {
            first_interval: 120,
            day_times: [32400, 75600]
          };
    const is_send_notice_before = localStorage.getItem("is_send_notice_before");
    const arr = [0, 1]; //除了今天，再注册两天的消息；
    //当前时刻的时间戳
    const nowTime = new Date().getTime();
    //当天零点的时间戳
    const todayZero = new Date(new Date().toLocaleDateString()).getTime();
    //距离当天24点的时间戳
    const leftTime = todayZero + 24 * 3600 * 1000 - nowTime;
    const day_times_List = this.levelNotification.day_times;
    const registTwoDayNotice = () => {
      for (let i = 0, len = arr.length; i < len; i++) {
        for (let j = 0, lens = day_times_List.length; j < lens; j++) {
          const timeInter =
            arr[i] * 24 * 3600 * 1000 + leftTime + day_times_List[j] * 1000;
          const data = this.getNoticePushData(timeInter);
          if (data !== "") {
            sendToNativeData += "&" + JSON.stringify(data);
          }
        }
      }
    };
    let sendToNativeData = "";
    if (is_send_notice_before === undefined) {
      const timeInterval = this.levelNotification.first_interval * 1000; //第一次发通知，第一天只发一条，第一条消息退出后台N秒后就发
      const pushData = timeInterval ? this.getNoticePushData(timeInterval) : "";
      if (pushData !== "") {
        sendToNativeData = "&" + JSON.stringify(pushData);
      }
      localStorage.setItem("is_send_notice_before", JSON.stringify(true));
      //循环注册未来两天的消息
      registTwoDayNotice();
    } else {
      //之前有发过通知，注册今天与后三天的通知
      //注册今天的通知
      for (const time of day_times_List) {
        if (nowTime < todayZero + time * 1000) {
          // tslint:disable-next-line:no-shadowed-variable
          const timeval = todayZero + time * 1000 - nowTime;
          const datapush = timeval ? this.getNoticePushData(timeval) : "";
          if (datapush !== "") {
            sendToNativeData += "&" + JSON.stringify(datapush);
          }
        }
      }
      //循环注册未来两天的消息
      registTwoDayNotice();
    }
    return sendToNativeData;
  };
  //计算池子里通知的权重
  private calcNoticeWeight = () => {
    this.totalWeight = 0;
    for (const val of this.needRandomNoticeList) {
      val.min = this.totalWeight;
      val.max = this.totalWeight + val.weight;
      this.totalWeight = val.max;
    }
  };
  private jugeIsHasBuyVip = () => {
    this.GxUserInfo = store.getters[types.GETTER_MASTER_SERVICE_DATA];
    if (
      this.GxUserInfo &&
      this.GxUserInfo.services &&
      this.GxUserInfo.services.length > 0
    ) {
      /**
       * 是否有购买过vip的记录
       */
      this.findService = this.GxUserInfo.services.find((service: any) => {
        //是vip
        return service.kind === "vip";
      });
      console.log(this.findService);
      return this.findService ? true : false;
    } else {
      return false;
    }
  };
  //判断是否含有订阅的通知
  private jugeNoticeHasSubscrip = () => {
    const userListInfo = store.getters[types.GETTER_CURRENT_INS_USER_INFO];
    const mainUserInfo = userListInfo && userListInfo.insUserInfo;
    if (mainUserInfo) {
      const followNum = mainUserInfo.follower_count;
      const follNotice =
        followNum < 1000
          ? this.subscripFollowNotice[0]
          : this.subscripFollowNotice[1];
      follNotice[0].text = follNotice[0].text.replace(
        "username",
        mainUserInfo.username
      );
      this.needRandomNoticeList.push({
        notice: follNotice,
        weight: 10
      });
      const likeNotice =
        followNum < 10000
          ? this.subscripLikeNotice[0]
          : this.subscripLikeNotice[1];
      this.needRandomNoticeList.push({
        notice: likeNotice,
        weight: 10
      });
    }
  };
  // 判断是否有specialfollow或者like
  private jugeNoitceListHasFollowOrLike = () => {
    const specialHistory = this.GxUserInfo.special_history;
    let specialLike, specialFollow;
    if (specialHistory) {
      specialFollow = specialHistory.find((val: any) => {
        return val.kind === "special_follow";
      });
      specialLike = specialHistory.find((val: any) => {
        return val.kind === "special_like";
      });
    }
    //没购买specialfollow
    if (specialHistory === undefined || !specialFollow) {
      this.specialFollowerNotice[0].text = `Hi, Claim Today’s Offer to GET ${getSpecialFollowNum()} Followers at ONLY $0.99 (Worth $9.99)🤑💰`;
      this.needRandomNoticeList.push({
        notice: this.specialFollowerNotice,
        weight: 100
      });
    }
    if (specialHistory === undefined || !specialLike) {
      //没购买speciallike
      this.needRandomNoticeList.push({
        notice: this.specialLikeNotice,
        weight: 50
      });
    }
  };
  //判断是否符合vip 免费试用三天
  private jugeNoitceListHasVipTrialThreeDay = () => {
    //vip 免费使用三天，客户不是vip;
    if (!this.isHasBuyVip) {
      this.needRandomNoticeList.push({
        notice: this.vipFreeTrialNotice,
        weight: 70
      });
    }
  };
  //判断是否有vip packge
  private jugeNoitceListHasVipPakage = () => {
    //当前月份vippakage没购买完
    if (
      this.GxUserInfo.vip_p_valid_count > 0 ||
      this.GxUserInfo.vip_p_valid_count === undefined
    ) {
      this.needRandomNoticeList.push({
        notice: this.vipPackageNotice,
        weight: 30
      });
    }
  };
  private jugeNoticeHasExpiredVip = () => {
    //是vip 并且vip过期 VIP过期isVipAndexpired为true
    let isVipAndExpired = false;
    if (this.findService && this.findService.hasOwnProperty("expire")) {
      //vip过期了
      isVipAndExpired =
        this.findService.expire >= this.GxUserInfo.server_current_time
          ? false
          : true;
    }
    if (isVipAndExpired) {
      this.needRandomNoticeList.push({
        notice: this.vipExpireNotice,
        weight: 70
      });
    }
  };
  //随机消息的类别
  private randomNoticeContent() {
    const randomNum = Math.floor(Math.random() * this.totalWeight);
    let noticeItem;
    for (let i = 0, len = this.needRandomNoticeList.length; i < len; i++) {
      if (
        this.needRandomNoticeList[i].min <= randomNum &&
        this.needRandomNoticeList[i].max > randomNum
      ) {
        noticeItem = this.needRandomNoticeList[i].notice;
        //当前通知随机到后，就从池子里删除，并且重新计算总的权重
        this.needRandomNoticeList.splice(i, 1);
        this.calcNoticeWeight();
        return noticeItem;
      }
    }
  }
  /*
   *发送的消息内容
   * @param val 必填  延迟的时间
   */
  private getNoticePushData(val: number) {
    timetest += 3000;
    //消息对象
    const noticeArr: any = this.randomNoticeContent();
    if (!noticeArr) {
      return "";
    }
    //随机消息的下标
    const num = Math.floor(Math.random() * noticeArr.length);
    const pushData = noticeArr[num].icon
      ? {
          title: noticeArr[num].title,
          content: noticeArr[num].text,
          customData: noticeArr[num].customData,
          timeInterval: val,
          imageUrl: noticeArr[num].icon,
          badgeNumber: 0
        }
      : {
          title: noticeArr[num].title,
          content: noticeArr[num].text,
          customData: noticeArr[num].customData,
          timeInterval: val,
          badgeNumber: 0
        };
    return pushData;
  }
}

const handleAccordWeightSendNotice = new HandleAccordWeightSendNotice();
export default handleAccordWeightSendNotice;
